import { ErrorLayout } from 'client/layouts/error/ErrorLayout';
import Image from 'next/image';

export const ErrorPage = () => {
	return (
		<ErrorLayout
			title="Aplicação em manutenção"
			className="h-fit flex-col lg:h-screen"
		>
			<div className="flex flex-col-reverse flex-wrap items-center justify-center lg:flex-row">
				<section className="relative block h-[36rem] w-full lg:w-[38.125rem]">
					<Image
						src="/app-maintenance.svg"
						alt="Aplicação em manutenção"
						fill
						className="object-contain"
					/>
				</section>
				<section className="mb-5 mt-8 flex flex-col items-center justify-center sm:items-start lg:mb-0">
					<h1 className="mb-9 text-8xl font-bold text-blue-500">Ops!</h1>
					<div className="flex h-fit w-full flex-col items-center justify-center sm:items-start lg:w-[32.5rem]">
						<p className="mb-6 text-xl font-medium leading-10 lg:text-[2.5rem]">
							Estamos em manutenção no momento.
						</p>
						<p className="mb-6 text-xl font-medium leading-10 lg:text-[2.5rem]">
							Por favor, aguarde para recarregar a página
						</p>
					</div>
				</section>
			</div>
		</ErrorLayout>
	);
};
